import * as ReactRouter from 'react-router-dom'
import * as React from 'react'

import * as Common from '@rushplay/common'

import * as Icons from './icons'
import { GameInfoSeoContent } from './game-info-seo-content'
import { GameTileAnimation } from './game-tile-animation'
import { GameTileSection } from './game-tile-section'
import { LiveCasinoGameTile } from './live-casino-game-tile'
import { useLiveCasinoTablesQuery } from './use-live-casino-tables-query'

export function LiveCasinoCategory() {
  const { category } = ReactRouter.useParams()
  const location = ReactRouter.useLocation()
  const [liveCasinoResponse, filtredGames] = useLiveCasinoTablesQuery(category)

  return (
    <React.Fragment>
      {filtredGames?.length === 0 || liveCasinoResponse.fetching ? (
        <Common.Box
          display="flex"
          justifyContent="center"
          alignSelf="center"
          fontSize={['48px', '64px']}
          pt={3}
        >
          <Icons.Spinner />
        </Common.Box>
      ) : (
        <GameTileSection
          size="medium"
          layout="grid"
          columns={filtredGames?.length}
        >
          {() =>
            filtredGames.length > 0 &&
            filtredGames.map((game, index) => (
              <GameTileAnimation
                key={`${category}-${game.id}`}
                delay={index * 0.04}
              >
                <ReactRouter.Link
                  to={`/casino/games/${
                    game.id
                  }?referrer=${location.pathname?.substring(1)}`}
                  style={{ display: 'inline-grid' }}
                >
                  <LiveCasinoGameTile game={game} size="medium" />
                </ReactRouter.Link>
              </GameTileAnimation>
            ))
          }
        </GameTileSection>
      )}

      <GameInfoSeoContent
        translationKey={`live-casino-category.${category}.seo-content`}
      />
    </React.Fragment>
  )
}
